var _style, _symbol;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 350 216",
    style: {
      enableBackground: "new 0 0 350 216"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:3;stroke-miterlimit:10;}\r\n")), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "contact",
    viewBox: "-127.9 -193.15 255.8 386.29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.62-191.65c-4.05,4.2-8.06,8.45-12.17,12.59c-7.2,7.26-14.47,14.45-21.93,21.9 C54.9-113.25,77.25-61.08,77.29-0.16C77.33,60.8,55.03,113,13.03,156.59c11.52,11.48,22.97,22.89,34.56,34.44 C58.66,180.14,68.86,167.9,78,154.77c26.69-38.35,42.92-80.76,47.1-127.21c7.55-83.71-17.93-156.26-76.08-217.23 c-0.59-0.62-1.11-1.32-1.66-1.98C47.12-191.65,46.87-191.65,46.62-191.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-56.44-87.33c23.25,24.26,35.7,53.37,35.68,87.41C-20.78,34.11-33.3,63.2-56.6,87.47 c11.55,11.52,22.93,22.88,34.31,34.24c65.64-61.89,69.35-176.52,0.18-243.48C-33.46-110.38-44.81-99-56.44-87.33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-125.78,18.13c11.51,11.47,22.96,22.89,34.42,34.31C-61.64,24.02-63.12-26.08-91.6-52.6 c-11.38,11.36-22.75,22.72-34.29,34.24C-116.27-6.3-116.14,6.06-125.78,18.13z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#contact",
    width: 255.8,
    height: 386.29,
    x: -127.9,
    y: -193.15,
    transform: "matrix(0.417 -0.1267 -0.1267 -0.417 173.8343 114.1787)",
    style: {
      overflow: "visible"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignal);
export default __webpack_public_path__ + "static/media/signal.fdf570db829915ccdbd69f5fe5bcf5ee.svg";
export { ForwardRef as ReactComponent };